import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { FontSize } from '../../../constants/Fonts';
import { Indexes, MediaQuery, Transition } from '../../../constants/Styles';

export const Container = styled.div`
  width: 100%;
  top: ${({ isHeaderDisplayed }) => (isHeaderDisplayed ? '0' : '-100px')};
  position: fixed;
  transition: ${Transition.TOP};
  background-color: ${Color.WHITE};
  z-index: ${Indexes.MODAL};

  ${MediaQuery.L_AND_DOWN} {
    position: initial;
    top: 0;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 20px 100px;
  display: flex;
  justify-content: center;

  ${MediaQuery.XL_AND_DOWN} {
    padding: 20px 50px;
  }

  ${MediaQuery.M_AND_DOWN} {
    padding: 10px 20px;
  }
`;

export const HorizontalLine = styled.span`
  border-bottom: 1px solid ${Color.MYSTIC};
  display: block;
  margin: 0 auto;
`;

export const BurgerNav = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  a {
    text-decoration: none;
  }

  ${MediaQuery.L_AND_DOWN} {
    justify-content: space-between;
  }
`;

export const BurgerButton = styled.button`
  background-color: transparent;
  border: none;
  display: none;
  cursor: pointer;

  svg {
    color: ${Color.BLUE_RIBBON};
    font-size: ${FontSize.XXL};
  }

  ${MediaQuery.L_AND_DOWN} {
    display: initial;
  }
`;
